import {Injectable} from '@angular/core';
import {RequestMethod, RestService} from './rest.service';
import {PageableResponse} from '../models/datasource/pageable-response';
import {Actions, ApiEndpoints} from '../constants/ApiEndpoints';
import {Observable} from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable()
export class StaffService {

  private certifyingBoardInactivePrograms = ['Medicare Physical Therapy', 'Medicare Rural Health', 'International Physical Therapy'];

  constructor(private restService: RestService) {}

  public getCertifyingTypes() {
    return new Observable<any>(obs => {
      this.restService.request<PageableResponse<any>>(RequestMethod.GET, ApiEndpoints.RES.CERTIFYING_BOARD,
        Actions.BASE_ACTIONS.READ).subscribe(res => {
        obs.next(res);
      });
    });
  }

  public getMemberBoardTypes(id: number) {
    return new Observable<any>(obs => {
      this.restService.request<PageableResponse<any>>(RequestMethod.GET, ApiEndpoints.RES.MEMBER_BOARD,
        `${Actions.BASE_ACTIONS.READ}/${id}`).subscribe(res => {
        obs.next(res);
      });
    });
  }

  isFieldRequired(facilityProgramDescription: string) {
    if (this.certifyingBoardInactivePrograms.includes(facilityProgramDescription)) { return false; }
    return !['International Surgical', 'International Clinic/Polyclinic', 'International Dental'].includes(facilityProgramDescription);
  }

  isActive(facilityProgramDescription: any) {
    return !this.certifyingBoardInactivePrograms.includes(facilityProgramDescription);
  }
}
